export default __webpack_public_path__ + "static/media/SoftUni.17a3f081.svg";